import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=3f68fd4b&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=3f68fd4b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f68fd4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f68fd4b')) {
      api.createRecord('3f68fd4b', component.options)
    } else {
      api.reload('3f68fd4b', component.options)
    }
    module.hot.accept("./TitleBar.vue?vue&type=template&id=3f68fd4b&scoped=true", function () {
      api.rerender('3f68fd4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TitleBar.vue"
export default component.exports